import 'react-native-web';

import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import {configureYup} from '@yoco/design-system-react-native';
configureYup({globalDefaultCountryCode: 'ZA'});
import { errorHandler } from './services/errorHandler';
import { analytics } from './services/analytics';

// Initialize error handler
errorHandler.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_COMMIT_SHA,
  sendDefaultPii: true,
});

// Initialize analytics
analytics.init({
  writeKey: import.meta.env.VITE_SEGMENT_WRITE_KEY,
});

// Global error handlers for unhandled promise rejections and errors
window.addEventListener('unhandledrejection', (event) => {
  errorHandler.captureException(event.reason);
});

window.addEventListener('error', (event) => {
  errorHandler.captureException(event.error || event.message);
});

async function main() {
  const App = (await import('./App.tsx')).default;

  createRoot(document.getElementById('app-root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

main();
